import image9 from "../assets/fb (14) 1.png"; // Image added
// import image10 from "../assets/Ideas.png"; // Image added

import React from "react";
import styled from "styled-components";
import ImageSlider from "../Commponents/ImageSlider";
import image1 from "../assets/fb (13) 2.png";
import image2 from "../assets/fb (13) 2.png";
import image3 from "../assets/fb (13) 2.png";
import image5 from "../assets/ourvalues_button.png";
import gifImage from "../assets/ideas.gif";
import gifimage1 from "../assets/appdesign.gif";
import gifimage2 from "../assets/app development.gif";
import gifimage3 from "../assets/qa_gif (1).png";
import gifimage4 from "../assets/artndesign_gif.png";
import gifimage5 from "../assets/notification (8) 1.png";
import image7 from "../assets/CDgame.png";
import image8 from "../assets/Ideas.png";
import image10 from "../assets/App design.png";
import image11 from "../assets/App development.png";
import image12 from "../assets/who are we_.png";
import image13 from "../assets/fb (15) 2.png";
import image14 from "../assets/game art n dev.gif";
import image15 from "../assets/web design n dev.gif";
import image16 from "../assets/expertise.gif";
import image17 from "../assets/Game art & Dev.png";
import image18 from "../assets/web design & dev.png";
import image19 from "../assets/expertise.png";
import image20 from "../assets/fb (17) 2.png";
import image21 from "../assets/Our Completed Projects.png";
import image22 from "../assets/fb (18) 1.png";
import image23 from "../assets/Pet Cat Simulator.png";
import image24 from "../assets/pngwing.com (4) 1.png";
import image25 from "../assets/pngwing.com (4) 2.png";
import image26 from "../assets/CD_Game.png";
import image27 from "../assets/CD Game Portfolio (20) 3.png";
import image28 from "../assets/testimonials.png";
import image29 from "../assets/fb (23) 1.png";
import image30 from "../assets/Dave Jackry.png";
import image31 from "../assets/fb (24) 2.png";
import image32 from "../assets/fb (22) 1.png";
import image33 from "../assets/fb (22) 2.png";
import image34 from "../assets/Blue_Element.png";
import image35 from "../assets/CD Game Portfolio (17) 1.png";
import image36 from "../assets/fb (16) 1.png";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react"; // Next icon
import image106 from "../assets/image 6.png";
import image107 from "../assets/image 7.png";
import image108 from "../assets/animal Simulator.png";
import image109 from "../assets/horse Simulator (1).png";
import image133 from "../assets/fb (3) 1.png";
import imageCdgame from "../assets/Gameport.png";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

const Wrap = styled.div`
  padding: 0px;
  margin: 0px;
  box-sizing: border-box;
  overflow-x: hidden;
`;

const Contanier3 = styled.div`
  width: 100%;
  position: relative;
  background: url(${image7});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding: 50px 0; */
  min-height: 600px;
  @media (min-width: 769px) and (max-width: 1024px) {
    min-height: 500px; /* Custom height for screens between 769px and 1024px */

  }
`;
const Contanier133 = styled.div`
  width: 100%;
  position: relative;
  background: url(${imageCdgame});
  background-size: cover;
  background-position: center;
  /* background-color: #f0efef; */
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding: 50px 0; */
  min-height: 600px;
  @media (min-width: 769px) and (max-width: 1024px) {
    min-height: 450px; /* Custom height for screens between 769px and 1024px */

  }
`;

const Contanier5 = styled.div`
  width: 100%;
  position: relative;
  background: url(${image26});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* background-color: red; */
  min-height: 600px;
  @media (max-width: 430px) {
    min-height: auto; /* Custom height for screens 430px or smaller */
  }
  
`;

const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 60px;
  width: 80%;
  padding: 10px;
  margin-top: 50px;
  margin-left: auto;
  margin-right: auto;
  /* background-color: red; */
  justify-content: center;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 40px;
    width: 90%;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    width: 95%;
    margin: 0 auto; /* ✅ Horizontally center */
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
    gap: 20px;
    width: 100%;
  }
`;

const ImageGrid5 = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 60px;
  width: 80%;
  padding: 10px;
  margin-left: auto;
  margin-right: auto;
  /* background-color: #00ff4c; */
  justify-content: center;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);

    gap: 10px;
    width: 90%;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    width: 95%;
    padding: 0px;
    margin: 0 auto; /* ✅ Horizontally center */
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
    gap: 45px;
    width: 100%;
    padding-bottom: 100px;
  }
`;

export const ImageGrid1 = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 60px;
  width: 100%;
  max-width: 85%;
  /* padding-left: 35px; */
  /* background-color: #002fff; */

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
const GridImage = styled.img`
  width: 249px;
  height: 106px;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;

  @media (max-width: 1200px) {
    width: 180px;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }

  @media (max-width: 768px) {
    width: 70%;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
  @media (max-width: 576px) {
    width: 100%;
    height: auto;
  }
`;

const GridImage29 = styled.img`
  width: 144px;
  height: auto;
  border-radius: 10px;
  position: absolute;
  bottom: -25%;
  right: 0%;
  z-index: 1; /* Ye neeche rahega */
  @media (max-width: 1200px) {
    width: 35%;
    height: auto;
    bottom: -25%;
    right: 10%;
    z-index: 1; /* Ye neeche rahega */
  }
  @media (max-width: 768px) {
    width: 35%;
    height: auto;
    bottom: -19%;
    right: 10%;
    z-index: 1; /* Ye neeche rahega */
  }

  @media (max-width: 576px) {
    width: 40%;
    height: auto;
    bottom: -15%;
    right: 0%;
    z-index: 1; /* Ye neeche rahega */
  }
`;
const GridImage30 = styled.img`
  width: 153px;
  height: auto;
  border-radius: 10px;
  position: absolute;
  right: -2%; /* 15% of 1200px */
  bottom: -26%;
  z-index: 1; /* Ye neeche rahega */
  @media (max-width: 1200px) {
    width: 36%;
    height: auto;
    bottom: -25%;
    right: 10%;
    z-index: 1; /* Ye neeche rahega */
  }

  @media (max-width: 768px) {
    width: 36%;
    height: auto;
    bottom: -20%;
    right: 10%;
    z-index: 1; /* Ye neeche rahega */
  }

  @media (max-width: 576px) {
    width: 41%;
    height: auto;
    bottom: -15%;
    right: -1%;
    z-index: 1; /* Ye neeche rahega */
  }
`;

const GridImage2 = styled.img`
  width: 27%;
  height: auto;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;

  @media (max-width: 576px) {
    width: 75px;
    height: 29;
  }
`;

const GridImage3 = styled.img`
  width: 45%;
  height: auto;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;

  @media (max-width: 576px) {
    width: 50%;
    height: auto;
  }
`;
const GridImage4 = styled.img`
  width: 70%;
  height: auto;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;

  @media (max-width: 576px) {
    width: 75%;
    height: auto;
  }
`;

const GridImage28 = styled.img`
  width: 144px;
  height: auto;
  border-radius: 10px;
  position: absolute;
  left: 15%;
  bottom: -12%;
  z-index: 1; /* Ye neeche rahega */
  @media (max-width: 768px) {
    width: 35%;
    height: auto;
    bottom: -5%;
    left: 10%;
    z-index: 1; /* Ye neeche rahega */
  }
  @media (max-width: 576px) {
    width: 40%;
    height: auto;
    bottom: -0%;
    left: 15%;
    z-index: 1; /* Ye neeche rahega */
  }
`;

const GridImage1 = styled.img`
  width: 325px;
  max-width: 100%;
  height: auto;
  border-radius: 10px;
  position: relative;
  top: 0%;
  /* background-color: yellow; */
  left: 1%;
  object-fit: cover;

  @media (max-width: 1200px) {
    width: 280px;
    top: 15%;
    left: 0%;
  }

  @media (max-width: 1024px) {
    width: 200px;
    top: 12%;
    left: 0%;
  }

  @media (max-width: 768px) {
    width: 200px;
    top: 10%;
    left: 0%;
  }

  @media (max-width: 576px) {
    width: 100%;
    top: 5%;
    left: 0;
  }
`;

const GridImage5 = styled.img`
  width: 325px;
  max-width: 100%;
  height: auto;
  border-radius: 10px;
  position: relative;
  top: 17%;
  /* background-color: yellow; */
  left: 1%;
  object-fit: cover;

  @media (max-width: 1200px) {
    width: 280px;
    top: 15%;
    left: 0%;
  }

  @media (max-width: 1024px) {
    width: 200px;
    top: 12%;
    left: 0%;
  }

  @media (max-width: 768px) {
    width: 200px;
    top: 10%;
    left: 0%;
  }

  @media (max-width: 576px) {
    width: 100%;
    top: 5%;
    left: 0;
  }
`;

const GridItem = styled.div`
  position: relative;
  display: inline-block;
  /* background-color: #0059ff; */

  

  @media (max-width: 768px) {
    position: relative;
    top: 0;
    left: 0;
    width: 80%;
    margin: 0 auto; /* ✅ Horizontally center */
  }
  @media (max-width: 576px) {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    margin: 0 auto; /* ✅ Horizontally center */
  }
  @media (max-width: 430px) {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    margin: 0 auto; /* ✅ Horizontally center */
  }
`;

export const GridItem1 = styled.div`
  position: relative;
  display: inline-block;
  /* background-color: #0059ff; */

  @media (max-width: 768px) {
    position: relative;
    top: 0;
    left: 0%;
    width: 80%;
    margin: 0 auto; /* ✅ Horizontally center */
  }
  @media (max-width: 576px) {
    position: relative;
    top: 0;
    left: 0;
    width: 80%;
    margin: 0 auto; /* ✅ Horizontally center */
  }
`;

export const GridItem3 = styled.div`
  position: relative;
  display: inline-block;
  /* background-color: #0059ff; */

  @media (max-width: 768px) {
    position: relative;
    top: 0;
    left: 55%;
    width: 80%;
    margin: 0 auto; /* ✅ Horizontally center */
  }
  @media (max-width: 576px) {
    position: relative;
    top: 0;
    left: 0;
    width: 80%;
    margin: 0 auto; /* ✅ Horizontally center */
  }
`;

export const GridItem5 = styled.div`
  position: relative;
  display: inline-block;
  /* background-color: #0059ff; */
  @media (max-width: 1200px) {
    position: relative;
    margin-left: 30px;
  }

  @media (max-width: 768px) {
    position: relative;
    top: 0;
    left: 0%;
    width: 80%;
    margin: 0 auto; /* ✅ Horizontally center */
  }
  @media (max-width: 576px) {
    position: relative;
    top: 0;
    left: 0;
    width: 80%;
    margin: 0 auto; /* ✅ Horizontally center */
  }
`;
export const GridItem4 = styled.div`
  position: relative;
  display: inline-block;
  /* background-color: #0059ff; */

  @media (max-width: 768px) {
    position: relative;
    top: 20px;
    left: 55%;
    width: 80%;
    margin: 0 auto; /* ✅ Horizontally center */
  }
  @media (max-width: 576px) {
    position: relative;
    top: 0;
    left: 0;
    width: 80%;
    margin: 0 auto; /* ✅ Horizontally center */
  }
`;
const OverlayText = styled.span`
  position: absolute;
  top: 60px;
  left: 44%;
  transform: translateX(-50%);
  color: #3b3b3b;
  /* background-color: pink; */
  font-size: 16px;
  z-index: 1;
  line-height: 1.6;

  @media (max-width: 1200px) {
    top: 95px;
    font-size: 14px;
    line-height: 1.4;
  }

  @media (max-width: 1024px) {
    top: 60px;
    font-size: 12px;
  }

  @media (max-width: 768px) {
    top: 50px;
    font-size: 12px;
  }

  @media (max-width: 576px) {
    top: 70px;
    left: 50%;
    font-size: 20px;
    text-align: center;
    line-height: 2;
    width: 70%;
  }
  @media (max-width: 500px) {
    top: 60px;
    left: 50%;
    font-size: 17px;
    text-align: center;
    line-height: 1.8;
    width: 70%;
    margin-top: 20px;
  }

  @media (max-width: 430px) {
    top: 50px;
    left: 50%;
    font-size: 15px;
    text-align: center;

    line-height: 1.8;
    width: 70%;
    margin-top: 20px;
  }
  @media (max-width: 375px) {
    top: 30px;
    left: 50%;
    font-size: 15px;
    text-align: center;
    line-height: 1.5;
    width: 70%;
    margin-top: 20px;
  }
  @media (max-width: 320px) {
    top: 20px;
    left: 50%;
    font-size: 15px;
    text-align: center;
    line-height: 1.8;
    width: 70%;
  }
`;

const OverlayText5 = styled.span`
  position: absolute;
  top: 120px;
  left: 44%;

  transform: translateX(-50%);
  color: #4d4b4b;
  line-height: 1.6;
  /* background-color: pink; */
  font-size: 16px;
  z-index: 1;

  @media (max-width: 1400px) {
    top: 120px;
    font-size: 16px;
  }

  @media (max-width: 1200px) {
    top: 100px;
    font-size: 15px;
  }

  @media (max-width: 1024px) {
    top: 60px;
    font-size: 12px;
  }

  @media (max-width: 768px) {
    top: 50px;
    font-size: 12px;
  }

  @media (max-width: 576px) {
    top: 70px;
    left: 50%;
    font-size: 20px;
    text-align: center;
    line-height: 2;
    width: 70%;
  }
  @media (max-width: 500px) {
    top: 60px;
    left: 50%;
    font-size: 17px;
    text-align: center;
    line-height: 1.8;
    width: 70%;
    margin-top: 20px;
  }

  @media (max-width: 430px) {
    top: 70px;
    left: 50%;
    font-size: 15px;
    text-align: center;
    line-height: 1.8;
    width: 70%;
    margin-top: 20px;
  }
  @media (max-width: 375px) {
    top: 50px;
    left: 50%;
    font-size: 15px;
    text-align: center;
    line-height: 1.5;
    width: 70%;
    margin-top: 20px;
  }
  @media (max-width: 320px) {
    top: 20px;
    left: 50%;
    font-size: 15px;
    text-align: center;
    line-height: 1.8;
    width: 70%;
  }
`;

const OverlayText28 = styled.span`
  position: absolute;
  bottom: -18%;
  left: 30%;
  transform: translateX(-50%);
  color: #838080;
  font-size: 15px;
  z-index: 1;

  @media (max-width: 576px) {
    position: absolute;
    bottom: -8%;
    left: 35%;
    transform: translateX(-50%);
    color: #838080;
    font-size: 15px;
    z-index: 1;
  }
`;
const OverlayText29 = styled.span`
  position: absolute;
  bottom: -25%;
  left: 30%;
  transform: translateX(-50%);
  color: #838080;
  font-size: 15px;
  z-index: 1;

  @media (max-width: 576px) {
    position: absolute;
    bottom: -12%;
    left: 35%;
    transform: translateX(-50%);
    color: #838080;
    font-size: 15px;
    z-index: 1;
  }
`;

const OverlayText1 = styled.span`
  position: absolute;
  top: 130px;
  left: 44%;
  transform: translateX(-50%);
  color: #000000;
  z-index: 2;
  font-size: 20px;

  @media (max-width: 1200px) {
    top: 120px;
    font-size: 18px;
  }

  @media (max-width: 992px) {
    top: 100px;
    font-size: 16px;
  }

  @media (max-width: 768px) {
    top: 80px;
    font-size: 14px;
  }

  @media (max-width: 576px) {
    top: 90px;
    left: 50%;
    font-size: 15px;
    text-align: center;
    line-height: 1.8;
    width: 70%;
  }
`;

const GifContainer = styled.div`
  position: absolute;
  top: 71px;
  right: 70px;
  width: 60px; /* Adjust the width as needed */
  height: 60px;

  @media (max-width: 768px) {
    position: absolute;
    top: 20px;
    right: 0;
    width: 100%;
  }
`;

const GifContainer1 = styled(GifContainer)`
  bottom: -2px;
  z-index: 2;
  left: 0px; /* Adjust this value to position the GIF */
  top: 90px;
`;

const GifContainer2 = styled(GifContainer)`
  position: absolute;
  z-index: 2;
  /* background-color: green; */
  left: 178px;
  top: 270px; /* Adjust this value to position the GIF */
  @media (max-width: 575px) {
    width: 100%;
    height: auto;
    position: absolute;
    left: 178px;
    top: 240px; /* Adjust this value to position the GIF */
  }
`;

const CenteredImage = styled.img`
  width: 25%;
  height: auto;
  display: block;
  margin: 70px auto 0 auto;

  @media (max-width: 1024px) {
    width: 35%;
  }

  @media (max-width: 768px) {
    width: 50%;
  }

  @media (max-width: 576px) {
    width: 65%;
  }

  @media (max-width: 430px) {
    width: 40%;
    margin-top: 40px;
  }
`;

const CenteredImage5 = styled.img`
  width: 25%;
  height: auto;
  display: block;
  margin: 70px auto 0 auto;

  @media (max-width: 1024px) {
    width: 35%;
  }

  @media (max-width: 768px) {
    width: 50%;
  }

  @media (max-width: 576px) {
    width: 65%;
  }

  @media (max-width: 430px) {
    width: 40%;
    margin: 40px auto 0 auto;
  }
`;

export const Contanier4 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 20px;
  /* background-color: #f709eb; */
  position: relative;
  @media (max-width: 768px) {
    padding: 0px;
  }
`;
const VisionImage = styled.img`
  display: block;
  margin: 30px auto;
  width: 48%;
  height: auto;

  @media (max-width: 1200px) {
    width: 60%;
  }

  @media (max-width: 992px) {
    width: 60%;
  }

  @media (max-width: 768px) {
    width: 60%;
    margin-top: 70px;
  }

  @media (max-width: 576px) {
    width: 60%;
  }
`;

export const GridItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  position: relative;
  background-color: green;
  @media (max-width: 576px) {
    flex-direction: row;
    align-items: center;

    justify-content: center;
    width: 100%;
    margin: 0 auto; /* ✅ Horizontally center */
    padding: 0px;
    gap: 0px;
  }
`;

export const SmallImage = styled.img`
  position: absolute;
  bottom: 8px;
  width: 287px;
  height: auto;
  background-color: #ffffff;
  border-radius: 5%;

  @media (max-width: 1200px) {
    width: 250px; /* Adjust width for medium screens */
  }

  @media (max-width: 992px) {
    width: 200px; /* Adjust width for smaller screens */
  }

  @media (max-width: 768px) {
    width: 150px; /* Adjust width for tablets */
    bottom: 5px; /* Adjust bottom position */
  }

  @media (max-width: 576px) {
    width: 120px; /* Adjust width for small screens */
    bottom: 2px; /* Adjust bottom position */
  }

  @media (max-width: 375px) {
    width: 100px; /* Adjust width for very small screens */
    bottom: 0; /* Adjust bottom position */
  }
`;
export const SmallImage1 = styled.img`
  position: absolute;
  top: 0px;
  left: 10px;
  z-index: 10;
  width: 203px;
  height: auto;
  /* background-color: #260ef7; */
  /* border-radius: 5%;  */
  /* border: 2px solid white; */
`;

export const ImgIso = styled.img`
  position: absolute;
  top: 210px;
  left: 0px;
  z-index: 10;
  width: 100px;
  height: 38px;
  /* background-color: #260ef7; */
  /* border-radius: 5%;  */
  /* border: 2px solid white; */
`;
export const Playstore = styled.img`
  position: absolute;
  top: 210px;
  left: 105px;
  z-index: 10;
  width: 100px;
  height: 38px;
  /* background-color: #260ef7; */
  /* border-radius: 5%;  */
  /* border: 2px solid white; */
`;
const SmallCont = styled.div`
  position: absolute;
  top: 10px;
  left: 100px;
`;

const ContanerItems = styled.div`
  position: absolute;
  top: 25px;
  left: 290px;
  width: 203px;
  height: auto;
  background-color: #0804c2;
  /* border-radius: 5%;  */
  /* border: 2px solid white; */
  z-index: 5;
`;
const OverlayText4 = styled.div`
  position: absolute;
  top: 30px;
  left: 10px;
  color: #000000;
  font-size: 17px;
  background-color: orange;
  line-height: 1.6;

  @media (max-width: 1200px) {
    top: 25px; /* Adjust top position for medium screens */
    font-size: 16px; /* Adjust font size */
  }

  @media (max-width: 992px) {
    top: 20px; /* Adjust top position for smaller screens */
    font-size: 15px; /* Adjust font size */
  }

  @media (max-width: 768px) {
    top: 15px; /* Adjust top position for tablets */
    left: 5px; /* Adjust left position */
    font-size: 14px; /* Adjust font size */
  }

  @media (max-width: 576px) {
    top: 10px; /* Adjust top position for small screens */
    left: 0; /* Center horizontally */
    font-size: 13px; /* Adjust font size */
    text-align: center; /* Center text */
    width: 100%; /* Full width for small screens */
  }

  @media (max-width: 375px) {
    top: 5px; /* Adjust top position for very small screens */
    font-size: 12px; /* Adjust font size */
  }
`;

const LeftArrow = styled.img`
  position: absolute;
  top: 50%;
  left: -90px;
  transform: translateY(-50%);
  width: 60px;
  height: 60px;
  cursor: pointer;
  @media (max-width: 1200px) {
    left: -70px; /* Adjust for medium screens */
  }
  @media (max-width: 1024px) {
    left: -50px; /* Adjust for smaller screens */
    width: 30px;
    height: 30px;
  }
  @media (max-width: 768px) {
    display: none; /* Hide on smaller screens */
  }
`;
const RightArrow = styled.img`
  position: absolute;
  top: 50%;
  right: -70px;
  transform: translateY(-50%);
  width: 60px;
  height: 60px;
  cursor: pointer;
  @media (max-width: 1200px) {
    right: -50px; /* Adjust for medium screens */
  }
  @media (max-width: 1024px) {
    right: -10px; /* Adjust for smaller screens */
    width: 30px;
    height: 30px;
  }
  @media (max-width: 768px) {
    display: none; /* Hide on smaller screens */
  }
`;

const BlueElementImage = styled.img`
  position: absolute;
  top: -100px;
  left: 0;
  width: auto;
  height: auto;
  z-index: 1;

  @media (max-width: 768px) {
    position: absolute; /* absolute ki jagah responsive banane ke liye */
    width: 15%; /* choti screen pe image choti hogi */
    height: auto;
    top: -80px;
    left: 0%;
    margin-top: 20px;
    z-index: 1;
  }

  @media (max-width: 576px) {
    position: absolute; /* absolute ki jagah responsive banane ke liye */
    width: 13%; /* choti screen pe image choti hogi */
    height: auto;
    top: -57px;
    left: 0%;
    /* transform: translateX(-50%); ✅ Perfect horizontal center */
    margin-top: 20px;
    z-index: 1;
  }
`;

const BlueElementImage1 = styled.img`
  display: flex;
  justify-content: left;
  align-items: left;
  left: 20px;
  top: -110px;
  position: absolute;

  @media (max-width: 1024px) {
    position: absolute; /* absolute ki jagah responsive banane ke liye */
    width: 15%; /* choti screen pe image choti hogi */
    height: auto;
    top: -80px;
    left: 0%;
    /* transform: translateX(-50%); ✅ Perfect horizontal center */
    margin-top: 20px;
    z-index: 1;
  }

  @media (max-width: 768px) {
    position: absolute; /* absolute ki jagah responsive banane ke liye */
    width: 25%; /* choti screen pe image choti hogi */
    height: auto;
    top: -100px;
    left: 0%;
    /* transform: translateX(-50%); ✅ Perfect horizontal center */
    margin-top: 20px;
    z-index: 1;
  }
  @media (max-width: 576px) {
    position: absolute; /* absolute ki jagah responsive banane ke liye */
    width: 20%; /* choti screen pe image choti hogi */
    height: auto;
    top: -57px;
    left: 0%;
    margin-top: 20px;
    z-index: 1;
  }
`;
const BlueElementImage2 = styled.img`
  display: flex;
  justify-content: left;
  align-items: left;
  right: 20px;
  top: -110px;
  /* position: relative; */
  position: absolute;
  @media (max-width: 1024px) {
    position: absolute; /* absolute ki jagah responsive banane ke liye */
    width: 15%; /* choti screen pe image choti hogi */
    height: auto;
    top: -98px;
    right: 0%;
    /* transform: translateX(-50%); ✅ Perfect horizontal center */
    margin-top: 20px;
    z-index: 1;
  }
  @media (max-width: 768px) {
    position: absolute; /* absolute ki jagah responsive banane ke liye */
    width: 25%; /* choti screen pe image choti hogi */
    height: auto;
    top: -100px;
    right: 0%;
    /* transform: translateX(-50%); ✅ Perfect horizontal center */
    margin-top: 20px;
    z-index: 1;
  }
  @media (max-width: 576px) {
    position: absolute; /* absolute ki jagah responsive banane ke liye */
    width: 20%; /* choti screen pe image choti hogi */
    height: auto;
    top: -66px;
    right: 0%;
    /* transform: translateX(-50%); ✅ Perfect horizontal center */
    margin-top: 20px;
    z-index: 1;
  }
`;

const GifImage = styled.img`
  position: absolute;
  bottom: -15px;
  right: 10px;
  width: 50%;
  height: auto;
  z-index: 3;
  /* background-color: red; */

  @media (max-width: 1200px) {
    bottom: -30px;
    width: 50%;
  }

  @media (max-width: 1024px) {
    width: 45%;
    position: absolute;
    bottom: 0px;
    right: 0px;
    z-index: 1;
    height: auto;
  }

  @media (max-width: 768px) {
    width: 45%;
    position: absolute;
    bottom: 0px;
    right: 0px;
    z-index: 1;
    height: auto;
  }

  @media (max-width: 576px) {
    width: 40%;
    position: absolute;
    bottom: 0px;
    right: 0px;
    z-index: 1;
    height: auto;
    /* background-color: red; */
  }
`;

const StyledDiv = styled.div`
  position: relative;
  width: 249px;
  height: 40px;
  bottom: 55px;
  @media (max-width: 1200px) {
    bottom: 10px;
    left: -30px;
  }

  @media (max-width: 1024px) {
    bottom: 5px;
    left: -30px;
  }
  @media (min-width: 576px) and (max-width: 768px) {
    bottom: 5px;
    left: -30px;
  }
  @media (max-width: 576px) {
    bottom: 30px;
    left: 0px;
  }
`;
const StyledDiv1 = styled.div`
  position: relative;
  width: 249px;
  height: 40px;
  bottom: 45px;

  @media (max-width: 1200px) {
    bottom: 5px;
    left: -30px;
  }

  @media (max-width: 1024px) {
    bottom: 5px;
    left: -30px;
  }

  @media (min-width: 576px) and (max-width: 768px) {
    bottom: 5px;
    left: -30px;
  }
  @media (max-width: 576px) {
    bottom: 15px;
    left: 0px;
  }
`;

const GridImage0 = styled.div`
  position: relative;
  width: 100%;
  height: 300px;
  background-color: #21dde4;
  background-size: cover;
  background-position: center;
  border-radius: 20px;
  overflow: hidden;
  border: 6px solid #20a0b1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;

  /* Tablet Screens */
  @media (max-width: 1024px) {
    height: 180px;
    padding: 15px;
    border-radius: 16px;
  }

  /* Mobile Screens */
  @media (max-width: 768px) {
    height: 250px;
    padding: 10px;
    border-radius: 14px;
    border-width: 4px;
  }

  /* Small Mobile Screens */
  @media (max-width: 480px) {
    height: 170px;
    padding: 8px;
    border-radius: 12px;
    border-width: 3px;
  }
`;

const OverlayContent = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  /* padding: 40px; */
  gap: 40px;
  
  /* background-color: rgba(0, 0, 0, 0.4); */
`;

const LeftDiv = styled.div`
  flex: 1;

  display: flex;
  justify-content: center;
  /* background-color: red; */
  align-items: center;

  img {
    width: 100%;
    height: 100%;
    border-radius: 12px;
  }
`;

const RightDiv = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  padding-right: 20px;
  gap: 20px;
  color: white;

  @media (max-width: 1024px) {
    padding-top: 10px;
    padding-right: 15px;
    gap: 15px;
  }

  @media (max-width: 768px) {
    padding-top: 20px;
    padding-right: 10px;
    gap: 10px;
  }

  @media (max-width: 576px) {
    padding-top: 10px;
    padding-right: 20px;
    gap: 10px;
  }

  @media (max-width: 430px) {
    padding-top: 15px;
    padding-right: 5px;
    gap: 8px;
  }
`;

const TopImage = styled.img`
  width: 100%;
  max-height: 200px;
  object-fit: cover;
  border-radius: 12px;
`;

const Description = styled.p`
  font-size: 16px;
  line-height: 1.5;
  color: #302f2f;

  @media (max-width: 1200px) {
    line-height: 1.2;
    font-size: 12px;
  }

  @media (max-width: 992px) {
    font-size: 10px;
  }

  @media (max-width: 768px) {
    font-size: 13px;
  }

  @media (max-width: 576px) {
    font-size: 11px;
     line-height: 1.2;
  }
  @media (max-width: 430px) {
    font-size: 12px;
    line-height: 1.2;
  }
`;

const BottomImages = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;

  img {
    width: 100%;
    height: auto;
    border-radius: 8px;
  }
`;

const Imaeg22 = styled.img`
  width: 100%;
  height: auto;
  border-radius: 6px;
  background-color: aliceblue;
`;

const ClickPortfolio = styled(Link)`
  font-size: 40px;
  color: black;
  font-weight: bold;
  text-decoration: none;
  /* background-color: pink; */
  display: flex;
  font-family: Calistoga;
  align-items: center;
  justify-content: flex-end; /* Left side alignment */
  gap: 10px;
  padding: 10px 20px;
  border-radius: 12px;
  transition: all 0.3s ease;
  width: fit-content;

  span.skyblue {
    color: #05d1f5;
    font-weight: bold;
    text-decoration: underline;
  }

  svg {
    transition: transform 0.3s ease;
  }

  &:hover {
    background-color: #f0f0f0;
    text-decoration: none;

    svg {
      transform: translateX(5px);
    }
  }
  @media (max-width: 1024px) {
    font-size:30px;
    width: 100%;
    height: auto;
    padding: 0px;
   
  }

  @media (max-width: 768px) {
    font-size: 22px;
    width: 100%;
    height: auto;
    padding: 0px;
    justify-content: center; /* Center alignment */
    align-items: center;
  }
`;
const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  /* background-color: red; */
  width: 100%;
  padding-right: 100px; /* Optional spacing from right */
  @media (max-width: 768px) {
    padding-right: 0px; /* Optional spacing from right */
    justify-content: center;
    align-items: center;
  }
  @media (max-width: 576px) {
    padding-right: 0px; /* Optional spacing from right */
    justify-content: center;
  }
  @media (max-width: 430px) {
    padding-right: 0px; /* Optional spacing from right */
    justify-content: center;
  }
  @media (max-width: 375px) {
    padding-right: 0px; /* Optional spacing from right */
    justify-content: center;
  }
`;
const Home = () => {
  useEffect(() => {
    AOS.init({ 
      duration: 1000,     // Animation duration
      once: false,        // Her baar animate karein jab visible ho
      mirror: true,       // Scroll up par bhi animate ho
      easing: 'ease-in-out',
      anchorPlacement: 'top-bottom', // Kab animate ho (jab top of element bottom of viewport ko touch kare)
      delay: 100
     });
    
  }, []);
  return (
    <>
      <Wrap>
        <ImageSlider />
        <Contanier3>
          <BlueElementImage src={image34} alt="Our Values" />
          <CenteredImage data-aos="fade-left" src={image12} alt="Our Vision" />
          <ImageGrid>
            <GridItem1 data-aos="flip-left">
              <OverlayText  >
                We take sparks of imageination and transform them onto
                actinoable concepts, ensuring your vision evolves into someting
                extrodinary and engaging.
              </OverlayText>
              <GridImage1  src={image2} alt="Vision Image 1" />
              <StyledDiv1 data-aos="zoom-in-right">
                <GridImage  src={image9} alt="Vision Image 1" />
                <GridImage2  src={image8} alt="Vision Image 2" />
              </StyledDiv1>

              <GifImage data-aos="zoom-in-left" src={gifImage} alt="Brainstorm GIF" />
            </GridItem1 >
            <GridItem1 data-aos="flip-left">
              <OverlayText>
                Function meets flair! We craft intuitive, eye-catching
                interfaces that don't just took great but offer seamless user
                experiences across all devices.
              </OverlayText>
              <GridImage1 src={image2} alt="Vision Image 1" />
              <StyledDiv1 data-aos="zoom-in-right">
                <GridImage src={image9} alt="Vision Image 1" />
                <GridImage3 src={image10} alt="Vision Image 1" />
              </StyledDiv1>

              <GifImage data-aos="zoom-in-left" src={gifimage1} alt="Brainstorm GIF" />
            </GridItem1>
            <GridItem3 data-aos="flip-left">
              <OverlayText>
                From blueprints to brilliance we build robust, high-performance
                apps that are as smooth and responsive as your favorite cup of
                coffee.
              </OverlayText>
              <GridImage1 src={image2} alt="Vision Image 1" />
              <StyledDiv1 data-aos="zoom-in-right">
                <GridImage src={image9} alt="Vision Image 1" />
                <GridImage4 src={image11} alt="Vision Image 1" />
              </StyledDiv1>

              <GifImage data-aos="zoom-in-left" src={gifimage2} alt="Brainstorm GIF" />
            </GridItem3>
          </ImageGrid>
        </Contanier3>

        <Contanier3>
          <ImageGrid>
            <GridItem1 data-aos="flip-left">
              <OverlayText>
                Pixels with personality! We create immersive worlds, stunning
                visuals, and addictive gameplay that keep players coming back
                for more.
              </OverlayText>
              <GridImage1 src={image13} alt="Vision Image 1" />
              <StyledDiv data-aos="zoom-in-right">
                <GridImage src={image9} alt="Vision Image 1" />
                <GridImage4 src={image17} alt="Vision Image 1" />
              </StyledDiv>

              <GifImage data-aos="zoom-in-left" src={image14} alt="Brainstorm GIF" />
            </GridItem1>
            <GridItem1 data-aos="flip-left">
              <OverlayText>
                More than just pretty pages-we build dynamic, interactive
                websites that are visually stunning, lightning-fast, and
                optimized for engagement.
              </OverlayText>
              <GridImage1 src={image13} alt="Vision Image 1" />
              <StyledDiv data-aos="zoom-in-right">
                <GridImage src={image9} alt="Vision Image 1" />
                <GridImage4 src={image18} alt="Vision Image 1" />
              </StyledDiv>

              <GifImage data-aos="zoom-in-left" src={image15} alt="Brainstorm GIF" />
            </GridItem1>
            <GridItem3 data-aos="flip-left">
              <OverlayText>
                We blend creativity, tech mastery , and gamification magic to
                build digital products that captivate, convert, and keep users
                entertained.
              </OverlayText>
              <GridImage1 src={image13} alt="Vision Image 1" />
              <StyledDiv data-aos="zoom-in-right">
                <GridImage src={image9} alt="Vision Image 1" />
                <GridImage3 src={image19} alt="Vision Image 1" />
              </StyledDiv>

              <GifImage data-aos="zoom-in-left" src={image16} alt="Brainstorm GIF" />
            </GridItem3>
          </ImageGrid>
        </Contanier3>

        <Contanier4>
          <BlueElementImage1 src={image35} alt="Our Values" />
          <BlueElementImage2 src={image36} alt="Our Values" />
          <VisionImage data-aos="fade-left" src={image21} alt="Our Completed Projects" />{" "}
          {/* Replace VisionTitle with image */}
          <ImageGrid1>
            <GridItem data-aos="flip-left">
              <GridImage0>
                <OverlayContent>
                  <LeftDiv>
                    <Imaeg22 src={image22} alt="Left Image" />
                  </LeftDiv>

                  <RightDiv>
                    <TopImage src={image23} alt="Top Image" />
                    <Description>
                      Enter the exciting new world of pet cat simulator. Explore
                      new locations, perform different tasks & unlock new
                      achivements!
                    </Description>
                    <BottomImages>
                      <img src={image25} alt="Bottom Image 1" />
                      <img src={image24} alt="Bottom Image 2" />
                    </BottomImages>
                  </RightDiv>
                </OverlayContent>
              </GridImage0>
            </GridItem>
            <GridItem data-aos="flip-left">
              <GridImage0>
                <OverlayContent>
                  <LeftDiv>
                    <Imaeg22 src={image106} alt="Left Image" />
                  </LeftDiv>

                  <RightDiv>
                    <TopImage src={image108} alt="Top Image" />
                    <Description>
                      Experience the fun filled & adventurous world of Animal
                      Simulator. Raise families, hunt for food, and face
                      thrilling challenges!
                    </Description>
                    <BottomImages>
                      <img src={image25} alt="Bottom Image 1" />
                      <img src={image24} alt="Bottom Image 2" />
                    </BottomImages>
                  </RightDiv>
                </OverlayContent>
              </GridImage0>
            </GridItem>

            <GridItem data-aos="flip-left">
              <GridImage0>
                <OverlayContent>
                  <LeftDiv>
                    <Imaeg22 src={image107} alt="Left Image" />
                  </LeftDiv>

                  <RightDiv>
                    <TopImage src={image109} alt="Top Image" />
                    <Description>
                      Saddle up! Ride into the sunset & race to become the best
                      Horse Rider in town. Show your racing skills in this horse
                      simulator.
                    </Description>
                    <BottomImages>
                      <img src={image25} alt="Bottom Image 1" />
                      <img src={image24} alt="Bottom Image 2" />
                    </BottomImages>
                  </RightDiv>
                </OverlayContent>
              </GridImage0>
            </GridItem>

            <GridItem data-aos="flip-left">
              <GridImage0>
                <OverlayContent>
                  <LeftDiv>
                    <Imaeg22 src={image22} alt="Left Image" />
                  </LeftDiv>

                  <RightDiv>
                    <TopImage src={image23} alt="Top Image" />
                    <Description>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua.
                    </Description>
                    <BottomImages>
                      <img src={image25} alt="Bottom Image 1" />
                      <img src={image24} alt="Bottom Image 2" />
                    </BottomImages>
                  </RightDiv>
                </OverlayContent>
              </GridImage0>
            </GridItem>

            <GridItem data-aos="flip-left">
              <GridImage0>
                <OverlayContent>
                  <LeftDiv>
                    <Imaeg22 src={image22} alt="Left Image" />
                  </LeftDiv>

                  <RightDiv>
                    <TopImage src={image23} alt="Top Image" />
                    <Description>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua.
                    </Description>
                    <BottomImages>
                      <img src={image25} alt="Bottom Image 1" />
                      <img src={image24} alt="Bottom Image 2" />
                    </BottomImages>
                  </RightDiv>
                </OverlayContent>
              </GridImage0>
            </GridItem>

            <GridItem data-aos="flip-left">
              <GridImage0>
                <OverlayContent>
                  <LeftDiv>
                    <Imaeg22 src={image22} alt="Left Image" />
                  </LeftDiv>

                  <RightDiv>
                    <TopImage src={image23} alt="Top Image" />
                    <Description>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua.
                    </Description>
                    <BottomImages>
                      <img src={image25} alt="Bottom Image 1" />
                      <img src={image24} alt="Bottom Image 2" />
                    </BottomImages>
                  </RightDiv>
                </OverlayContent>
              </GridImage0>
            </GridItem>
          </ImageGrid1>
          <Wrapper>
            <ClickPortfolio to="/gameportfolio">
              Click <span className="skyblue">Here</span> for Our PortFolio{" "}
              <ArrowRight size={30} strokeWidth={3} />
            </ClickPortfolio>
          </Wrapper>
        </Contanier4>

        <Contanier133>
          <CenteredImage5 data-aos="fade-left" src={image28} alt="Our Vision" />
          <ImageGrid5>
            <GridItem5 data-aos="flip-left">
              <LeftArrow src={image32} alt="Vision Image 1" />
              {/* <RightArrow src={image30} alt="Vision Image 1" /> */}
              <OverlayText5>
                They assured and kept the game High Quality & were always
                available for a call to discuss updates and feedback
              </OverlayText5>
              <GridImage5 src={image27} alt="Vision Image 1" />
              <GridImage29 src={image29} alt="Vision Image 1" />
              <GridImage30 src={image31} alt="Vision Image 1" />
              <GridImage28 src={image30} alt="Vision Image 1" />
              <OverlayText28>Head of Games</OverlayText28>
              {/* <GridImage2 src={image8} alt="Vision Image 1" /> */}
            </GridItem5>

            <GridItem5 data-aos="flip-left">
              <OverlayText5 >
                My experience has been nothing but positive. Because of thier
                professionalism, speed of work and communication quality.
              </OverlayText5>
              <GridImage5 src={image27} alt="Vision Image 1" />
              <GridImage29 src={image29} alt="Vision Image 1" />
              <GridImage30 src={image31} alt="Vision Image 1" />
              <GridImage28 src={image30} alt="Vision Image 1" />
              <OverlayText29>
                Senior Product <br></br> Manager
              </OverlayText29>
              {/* <GridImage2 src={image8} alt="Vision Image 1" /> */}
            </GridItem5>
            <GridItem4 data-aos="flip-left">
              <OverlayText5>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </OverlayText5>
              <GridImage5 src={image27} alt="Vision Image 1" />
              <GridImage29 src={image29} alt="Vision Image 1" />
              <GridImage30 src={image31} alt="Vision Image 1" />
              <GridImage28 src={image30} alt="Vision Image 1" />
              <OverlayText28>Mobile App</OverlayText28>
              {/* <GridImage2 src={image8} alt="Vision Image 1" /> */}
              <RightArrow src={image33} alt="Vision Image 1" />
            </GridItem4>
          </ImageGrid5>
        </Contanier133>
      </Wrap>
    </>
  );
};

export default Home;
